import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export const Logo = ({ variant = 'light', className = '', scrolled = false }) => {
  const height = scrolled ? 80 : 200;
  const isLight = variant === 'light';
  const sparkleColor = isLight ? '#F5E6C4' : '#C5A46D';

  // Shooting-star intro plays once per session
  const [flyIn, setFlyIn] = useState(false);
  useEffect(() => {
    try {
      if (!sessionStorage.getItem('nh_logo_flyin_played')) {
        setFlyIn(true);
        sessionStorage.setItem('nh_logo_flyin_played', '1');
      }
    } catch { /* private mode / storage disabled */ }
  }, []);

  return (
    <Link to="/" data-testid="logo-link" className={`relative inline-flex items-center shrink-0 ${className}`}>
      <img
        src="/images/nova-logo.webp"
        alt="Nova Homes — Premium 2 & 3 BHK Flats in Rahatani, Pune"
        style={{ height: `${height}px`, transition: 'height 0.3s ease' }}
        className={`w-auto relative z-10 ${isLight ? 'brightness-0 invert' : ''}`}
      />

      {/* Sparkle twinkle overlay — positioned exactly over the 4-point star.
          Outer span handles the shooting-star intro (translateX only, straight-line);
          inner span keeps the resting centering transform and continuous shimmer. */}
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute z-20 ${flyIn ? 'nova-logo-flyin' : ''}`}
        style={{
          left: '27.5%',
          top: '48.5%',
          width: `${height * 0.30}px`,
          height: `${height * 0.30}px`,
          transition: 'width 0.3s ease, height 0.3s ease',
        }}
      >
        <span
          className="nova-logo-twinkle nova-logo-twinkle--big"
          style={{
            display: 'block',
            width: '100%',
            height: '100%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
            '--twinkle-color': sparkleColor,
          }}
        />
      </span>
    </Link>
  );
};
